import { createFileRoute } from '@tanstack/react-router';

import InputMessage from 'src/components/chat/InputMessage';
import MessagesHistory from 'src/components/chat/MessagesHistory';
import SuggestedPrompts from 'src/components/chat/SuggestedPrompts';
import PageHeader from 'src/components/ui/page-header';

export const Route = createFileRoute('/chat')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="flex h-full min-h-screen w-full flex-col bg-gradient-to-r from-[#F7EDE2] to-[#ECE1F0]">
      <PageHeader
        title="Chat with Ms.Acie"
        backHref="/"
        className="bg-gradient-to-r from-[#F7EDE2] to-[#ECE1F0]"
      />
      <MessagesHistory />
      <SuggestedPrompts />
      <InputMessage />
    </div>
  );
}
